import { faStar } from "@jewlr/pro-regular-svg-icons/faStar"
import { faStar as solidStar } from "@jewlr/pro-solid-svg-icons/faStar"
import { faStarHalfAlt as solidStarHalf } from "@jewlr/pro-solid-svg-icons/faStarHalfAlt"
import { Box, Button, FontAwesomeIcon, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"

import withReviews from "areas/product/hoc/with-reviews"
import { roundToHalf } from "helpers/round-to-half"

const Wrapper = styled.div`
  font-size: ${(props) => props.fontSize || "12px"};
  line-height: 1;
  margin-top: ${(props) => (props.miniview ? "5px" : "0")};
`
const StyledStars = styled(Box).attrs((props) => ({
  justifyContent: { _: "center", desktop: "flex-start" },
  ...props,
}))`
  align-items: center;
  color: #f7bf4d;
  display: flex;
  margin-right: 2px;
`
const StyledStar = styled(FontAwesomeIcon)`
  color: #f7bf4d;
  margin-right: 2px;
`
const StyledReviewCount = styled(Typography).attrs((props) => ({
  as: "span",
  color: "primary",
  fontSize: 12,
  ...props,
}))`
  margin-left: 3px;
`

/**
 * Ratings/reviews component.
 *
 * @author [Adi Bakija]
 */
const InternalRatings = ({
  countStyle,
  fontSize,
  handleClick,
  miniview,
  ratings,
  style,
}) => {
  let displayReview = ratings?.average_score >= 4 || false
  if (!displayReview) return null

  let average_rating = roundToHalf(ratings.average_score, 0.5)
  let starArray = []
  for (let i = 1; i <= 5; i++) {
    if (i <= average_rating) {
      starArray.push(
        <StyledStar color={"#F7BF4D"} icon={solidStar} key={i} width={12} />
      )
    } else if (i <= average_rating + 0.5) {
      starArray.push(
        <StyledStar color={"#F7BF4D"} icon={solidStarHalf} key={i} width={12} />
      )
    } else {
      starArray.push(
        <StyledStar color={"#F7BF4D"} icon={faStar} key={i} width={12} />
      )
    }
  }
  return (
    <Button
      display="block"
      mx={{ _: "auto", tablet: "unset" }}
      onClick={handleClick}
      variant="text"
    >
      <Wrapper data-cy="product-rating" fontSize={fontSize} miniview={miniview}>
        {displayReview && (
          <StyledStars {...style}>
            {starArray.map((star) => star)}
            <StyledReviewCount {...countStyle}>
              {ratings.total_review} reviews
            </StyledReviewCount>
          </StyledStars>
        )}
      </Wrapper>
    </Button>
  )
}

InternalRatings.propTypes = {
  countStyle: PropTypes.object,
  fontSize: PropTypes.string,
  handleClick: PropTypes.func,
  miniview: PropTypes.bool,
  ratings: PropTypes.object,
  style: PropTypes.object,
}

export default withReviews(InternalRatings)
